import 'src/styles/common.scss';
import 'src/styles/styles.scss';
import 'src/styles/non-critical.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-tooltip/dist/react-tooltip.css';
import "src/styles/simplebars.css";
import '@bellsoft-ui-react/navigation/dist/esm/index.css';
import '@bellsoft-ui-react/modals/dist/esm/index.css';

import {copyTextToClipboard} from "./src/components/DownloadUniversal/DownloadOSItem/utils";
import SimpleBar from "simplebar";

export const onRouteUpdate = ({ location, prevLocation }) => {
    console.log("ReactDOM.render has executed")


    // Ignoring hash changes
    if (location.pathname !== prevLocation?.pathname) {
        const codeBoxes = document.querySelectorAll("pre[class^=language-]:not([data-disable-code-copy])")

        for (const box of codeBoxes) {
            const code = box.querySelector("code")
            if(code) {
                const button = document.createElement("button");
                button.className = "code-copy-button"
                button.innerHTML = 'Copy';
                button.addEventListener("click", () => {
                    button.innerHTML = 'Copied!';
                    setTimeout(() => {
                        button.innerHTML = 'Copy'
                    }, 1000);
                    copyTextToClipboard(code.textContent)
                })
                box.append(button)
            }
        }

        Array.prototype.forEach.call(
            document.querySelectorAll('.blog-content table, .old-docs-content table, .docs-content table.tableblock, .el-scrollable, .el-scrollable-thin'),
            (el) => new SimpleBar(el, { autoHide: false })
        );
    }
}

export const onPreRouteUpdate = () => {
}